module.exports = __webpack_public_path__ + "static/media/light_whole_food.0491e954.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/light_whole_food.svg
// module id = 397
// module chunks = 0